module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/421.daff4b4d.png";